export var hitsToLinkedContents = function hitsToLinkedContents(hits) {
  return hits.map(function (hit) {
    return hitToLinkedContent(hit);
  });
}; // TODO create a type above Hit to fix typescript errors instead of using as

export var hitToLinkedContent = function hitToLinkedContent(hit) {
  return {
    id: hit.objectID,
    label: hit.label,
    previewImage: hit.previewImage
  };
};